// removed by extract-text-webpack-plugin
module.exports = {"PropertyName":"PropertyName--2JBUD","Name":"Name--2DDq_","Edit":"Edit--3a3Ly","EditName":"EditName--36aa1"};